import { captureException } from '@sentry/gatsby';
import isEmail from 'validator/lib/isEmail';
import isEmpty from 'validator/lib/isEmpty';
import PardotFormApi from '../../Utilities/pardotFormApi';

const resetForm = (setData, setValidation) => {
  setData({
    firstname: '',
    email: '',
    nominatedname: '',
    nominatedcompany: '',
    nominatedreason: '',
  });
  setValidation({
    firstname: '',
    email: '',
    nominatedname: '',
    nominatedcompany: '',
    nominatedreason: '',
  });
};

export const handleClass = (value, name, validation) => {
  if (validation[name]) return 'invalid';
  if (name === 'email') {
    if (!isEmpty(value) && !isEmail(value)) {
      return 'invalid';
    }
  }
  if (!isEmpty(value)) return 'valid';
  return '';
};

export const handleSubmit = (
  e,
  formHandler,
  data,
  setData,
  validation,
  setValidation,
  setSuccess
) => {
  e.preventDefault();

  for (const key in validation) {
    if (isEmpty(data[key])) {
      setValidation({
        ...validation,
        [key]: 'Please complete required field',
      });
      return;
    }
    if (key === 'email') {
      if (!isEmail(data[key])) {
        setValidation({
          ...validation,
          [key]: 'Must be a valid email address',
        });
        return;
      }
    }
  }
  PardotFormApi.maintanenceAppreciation(data, formHandler)
    .then(() => {
      setSuccess(true);
      resetForm(setData, setValidation);
      setTimeout(() => {
        setTimeout(() => {
          setSuccess(false);
        }, 1000);
      }, 5000);
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.error('Error submitting Maintenance Appreciation form', error);
      captureException(`Maintenance Appreciation Form Error - ${error}`);
    });
};
